import { IconEdit, IconShield } from '../../../../shared/icon/icon'
import { SECTION } from '../../../../shared/navigation/sections'

// The crumbs of the staff organization pages, named once so a page reached
// FROM an organization can rebuild the trail that led to it: the Connect
// page opened from an organization's SSO tab (provider-connect.js) reads
// "Organizations > <name> > SSO > Connect single sign-on", each earlier
// crumb going back where it came from.

// The list: the sidebar's entry (shared/navigation/sections.js).
export const ORGANIZATIONS_BREADCRUMB = SECTION.organizations

// The organization edit page's SSO tab: its button and its crumb read the
// same word (not the path segment "sso").
export const ORGANIZATION_SSO_TAB = { text: 'SSO', Icon: IconShield }

export const organizationEditUrl = organizationID => `/admin/organization/list/edit/${organizationID}`

// A connection opened from the organization's SSO tab lives under it, so the
// trail keeps the organization ("Organizations > <name> > SSO > <connection>"),
// Organizations stays lit, and a reload of the address shows the same trail.
// Opened from the SSO connections list it is /admin/sso/connections/:id.
export const organizationConnectionUrl = (organizationID, providerID) => `${organizationEditUrl(organizationID)}/sso/connections/${providerID}`

// "Organizations > <name> > SSO". The name is the organization's own; until
// it is known the crumb names the organization by its id.
export const organizationSsoTrail = (organizationID, organizationName) => [
  ORGANIZATIONS_BREADCRUMB,
  { url: organizationEditUrl(organizationID), text: organizationName || `Organization ${organizationID}`, Icon: IconEdit },
  { url: `${organizationEditUrl(organizationID)}/sso`, ...ORGANIZATION_SSO_TAB }
]
